import packageJson from '../../../package'

export default {
    VERSAO: packageJson.version,
    NOME: 'patrimonio-mobiliario',
    PARAMETRO_NAMESPACE: 'az.compra-direta',
    COPYRIGHT: 'Todos os direitos reservados',
    LOGOUT_URL: '/hal/logout'
}